import Model from '../Apis/SessionAttendance'
import Controller from './Controller'

export default class SessionAttendanceController extends Controller {
  constructor() {
    super(new Model())
  }
  async getUserAttendLecture(params) {
    const response = await this.model.getUserAttendLecture(params);
    return response
  }
  async attendLecture(params) {
    const response = await this.model.attendLecture(params);
    return response
  }
  async getStudentAttend(params) {
    const response = this.model.getStudentAttend(params);
    return response
  }
}
